var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 11.729h6.75v-.521q0-.937-.927-1.5-.927-.562-2.448-.562t-2.448.562q-.927.563-.927 1.5Zm3.396-3.333q.708 0 1.208-.49.5-.489.5-1.218 0-.73-.5-1.219-.5-.49-1.208-.49-.729 0-1.219.49-.49.489-.49 1.219 0 .729.49 1.218.49.49 1.219.49Zm-8.354 9.937V3.417q0-.729.51-1.24.511-.51 1.24-.51h13.166q.729 0 1.24.51.51.511.51 1.24v9.833q0 .729-.51 1.24-.511.51-1.24.51H5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaFeedbackIcon);
export default __webpack_public_path__ + "static/media/idea-feedback-icon.f94cf7cad0c0268e99ea8cbcca924aa6.svg";
export { ForwardRef as ReactComponent };